<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    import enumService from '../services/enumService'
    import afflictionTypeEnum from '../enums/afflictionType'
    import afflictionRuleEnum from '../enums/afflictionRule'

    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                fields: [
                    { type: 'text', text: 'Name', value: 'name', rules: [v => !!v || 'Name is required', v => !(v && v.length > 100) || 'Name must be less than 100 characters'], isRequired: true, maxLength: 100 },
                    { type: 'enum', text: 'Pest/Disease Type', value: 'afflictionType', rules: [v => (v !== null && v !== '') || 'Pest/Disease Type is required'], isRequired: true, items: enumService.enumAsSelectList(afflictionTypeEnum) },
                    { type: 'enum', text: 'Pest/Disease Rule', value: 'afflictionRule', rules: [v => (v !== null && v !== '') || 'Pest/Disease Rule is required'], isRequired: true, items: this.enumAsSelectList(afflictionRuleEnum) }
                ],
                apiMethod: 'Afflictions',
                formTitle: 'Pest/Disease',
            }
        },

        methods: {
            enumAsSelectList(enumDictionary) {
                return Object.keys(enumDictionary).map((k) => {
                    return {
                        value: k,
                        text: (String(k) === "AmericanFoulbrood" ? "AFB" : k) + (String(k) !== "None" ? " (Notifiable)" : "")
                    };
                });
            }
        }
    };
</script>
